import { Link } from "react-router-dom";
import Footer from "@/components/site/Footer";
import BookingSidebar from "@/components/site/BookingSidebar";
import village from "@/assets/tour-kampong-kleang.jpg";


const schedule = [
  { time: "8:00 AM", title: "Hotel Pickup in Siem Reap", body: "Your driver will pick you up from your hotel in Siem Reap." },
  { time: "8:00 – 9:30 AM", title: "Drive to Kampong Kleang", body: "Scenic drive through the Cambodian countryside to Kampong Kleang village." },
  { time: "9:30 AM – 12:30 PM", title: "Explore Kampong Kleang", body: "Explore stilt houses & local village life. Boat trip through canals and floating homes. Visit floating schools, markets & pagoda." },
  { time: "12:30 PM", title: "Lunch Break", body: "Enjoy lunch at a local restaurant or floating house." },
  { time: "1:30 – 3:00 PM", title: "Continue Boat Ride on Tonlé Sap Lake", body: "Continue boat ride on Tonlé Sap Lake. Enjoy countryside views and photography." },
  { time: "3:00 PM", title: "Return to Siem Reap", body: "Begin the journey back to Siem Reap." },
  { time: "4:30 – 5:00 PM", title: "Hotel Drop-off", body: "Arrive back at your hotel in Siem Reap." },
];

const TourKampongKleang = () => {
  return (
    <main className="bg-background">
      {/* HERO */}
      <header className="relative bg-jungle text-background overflow-hidden">
        <img
          src={village}
          alt="Kampong Kleang floating village tour near Siem Reap with private French-speaking guide on Tonlé Sap"
          width={1920}
          height={1280}
          className="absolute inset-0 h-full w-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-jungle/70 via-jungle/50 to-jungle/95" />
        <div className="relative z-10">
          <div className="container flex items-center justify-between py-6">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-display text-2xl tracking-wide">Aṅkor</span>
              <span className="text-[10px] uppercase tracking-[0.3em] opacity-70 hidden sm:inline">Sojourns</span>
            </Link>
            <Link to="/tours" className="text-[11px] uppercase tracking-[0.3em] border-b border-background/40 pb-1 hover:border-primary hover:text-primary transition-colors">
              ← All Tours
            </Link>
          </div>
          <div className="container pt-20 pb-32 md:pt-28 md:pb-44 max-w-5xl">
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— One Day Sojourn</p>
            <h1 className="font-display text-5xl md:text-7xl leading-[0.95] text-balance lg:text-2xl">
              Kampong Kleang <em className="font-light">—</em> Floating Village &amp; Local Life.
            </h1>
            <p className="mt-10 max-w-xl text-background/70 leading-relaxed text-xl font-light">
              Experience authentic local life at Kampong Kleang, one of the largest and least touristy fishing villages on Tonlé Sap Lake. Discover stilt houses, floating communities, and daily life on the water with a scenic boat through canals and flooded forests.
            </p>
            <div className="mt-10 flex flex-wrap gap-x-10 gap-y-3 text-[11px] uppercase tracking-[0.3em] text-background/80">
              <span>Duration · ~9 Hours</span>
              <span>Group · 1–15</span>
              <span>From $95 / pax</span>
            </div>
          </div>
        </div>
      </header>

      {/* INTRO */}
      <section className="py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Tonlé Sap</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-10 text-balance">
            A full day inside one of Cambodia's most authentic fishing communities.
          </h2>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>
              Kampong Kleang sits on the northern shore of Tonlé Sap, the great inland sea of Southeast Asia. Its towering stilt houses rise ten metres above the dry-season earth and float in the flood months — a rhythm of life unchanged for generations.
            </p>
            <p>
              Far from the tourist circuits, you'll glide by long-tail boat through the village canals, past floating schools, markets, and pagodas, and out into the open lake.
            </p>
          </div>
        </div>
      </section>

      {/* TIMELINE */}
      <section className="pb-24 md:pb-32">
        <div className="container max-w-6xl"><div className="grid lg:grid-cols-[1fr_420px] gap-x-12 gap-y-12 items-start"><div>
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Itinerary</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">
            What you will do, hour by hour.
          </h2>
          <ol className="relative border-l border-border pl-8 md:pl-10 space-y-12">
            {schedule.map((s) => (
              <li key={s.time} className="relative">
                <span className="absolute -left-[41px] md:-left-[49px] top-1 h-3 w-3 rounded-full bg-primary ring-4 ring-background" />
                <p className="text-[11px] uppercase tracking-[0.3em] text-primary mb-2">{s.time}</p>
                <h3 className="font-display text-2xl md:text-3xl mb-3">{s.title}</h3>
                <p className="text-muted-foreground font-light leading-relaxed text-lg">{s.body}</p>
              </li>
            ))}
          </ol>
        </div><BookingSidebar pricePerPerson={95} tourTitle="Kampong Kleang Floating Village" pricingTiers={[{ maxPax: 2, price: 95 }, { maxPax: 6, price: 125 }, { maxPax: 10, price: 155 }]} /></div></div>
      </section>

      {/* PRICE */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Price (Estimated)</p>
          <ul className="space-y-4 font-light text-lg">
            <li className="border-b border-border pb-4 flex justify-between"><span>Private Tour (1–2 pax)</span><span>$95 total</span></li>
            <li className="border-b border-border pb-4 flex justify-between"><span>Group (3–6 pax)</span><span>$125 total</span></li>
            <li className="pb-4 flex justify-between"><span>Boat Ticket</span><span>$20 / person</span></li>
          </ul>
        </div>
      </section>

      {/* INCLUDED / NOT INCLUDED */}
      <section className="py-24 md:py-32">
        <div className="container max-w-5xl grid md:grid-cols-2 gap-x-12 gap-y-12">
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Includes</p>
            <ul className="space-y-4 font-light text-lg">
              <li className="border-b border-border pb-4">Private transport (A/C)</li>
              <li className="border-b border-border pb-4">Driver</li>
              <li className="border-b border-border pb-4">Drinking water</li>
              <li className="pb-4">Hotel pickup &amp; drop-off</li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Excludes</p>
            <ul className="space-y-4 font-light text-lg">
              <li className="border-b border-border pb-4">Boat ticket ($20–$25)</li>
              <li className="border-b border-border pb-4">Meals &amp; drinks</li>
              <li className="pb-4">Tour guide (optional)</li>
            </ul>
          </div>
        </div>
      </section>

      {/* WHAT TO BRING */}
      <section className="bg-secondary py-24 md:py-32">
        <div className="container max-w-5xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Essential Items</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-16 text-balance">What to bring, what to leave behind.</h2>
          <div className="grid md:grid-cols-3 gap-x-10 gap-y-12">
            <div>
              <h3 className="font-display text-2xl mb-5">Required</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Flashlight or phone light</li>
                <li>Modest clothing shoulders &amp; knees covered</li>
                <li>Comfortable walking shoes</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Recommended</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Camera with extra batteries</li>
                <li>Small backpack</li>
                <li>Cash for breakfast</li>
                <li>Sun protection hat, sunscreen</li>
              </ul>
            </div>
            <div>
              <h3 className="font-display text-2xl mb-5">Leave at Hotel</h3>
              <ul className="space-y-3 font-light text-muted-foreground">
                <li>Passport (bring a copy)</li>
                <li>Airline tickets</li>
                <li>Excess cash</li>
                <li>Valuable jewellery</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* GOOD TO KNOW */}
      <section className="py-24 md:py-32">
        <div className="container max-w-4xl">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Good to Know</p>
          <div className="space-y-6 text-lg font-light text-muted-foreground leading-relaxed">
            <p>Sunrise tours are the most popular and tend to sell out quickly, especially during the dry season (November to March). We recommend booking at least 48 hours in advance during peak season, even earlier.</p>
            <p>Pickup time: 7:30 – 8:00 AM (exact time confirmed one day before). Tour ends 1:30 – 2:30 PM.</p>
            <p>Breakfast: if your hotel includes breakfast, request a takeaway box, or stop at a local restaurant.</p>
            <p>Dress code: casual but respectful covered shoulders and knees required inside temples. Comfortable walking shoes are strongly recommended.</p>
            <p>For safety, leave valuables at your hotel and bring only what you need. This tour is not wheelchair accessible. Children under 5 are not permitted. Maximum group size: 1–15 travellers in an air-conditioned vehicle.</p>
            <p>
              <span className="text-foreground">Weather.</span> Hot and dry throughout. There is always the possibility of a shower or two, but it is likely to be dry most of the time. Midday temperatures are likely to be very hot, but most of the woodland sites we visit have low humidity.
            </p>
            <p>
              <span className="text-foreground">Food.</span> Khmer cuisine is similar to most Southeast Asian cooking, but rather less spicy. Good bread is available in many areas thanks to the French influence, and there is a surprisingly wide range of local brews to try.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="pb-24 md:pb-32">
        <div className="container max-w-3xl text-center">
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-6">— Reserve Your Day</p>
          <h2 className="font-display text-4xl md:text-6xl leading-[1.05] mb-10 text-balance">
            The lake is waiting.
          </h2>
          <Link
            to="/#contact"
            className="inline-block bg-foreground text-background px-10 py-4 text-[11px] uppercase tracking-[0.3em] hover:bg-primary transition-colors"
          >
            Book Now →
          </Link>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default TourKampongKleang;
